/**
 *
 * @module sessionLocationType
 *
 */

/* eslint new-cap: 'off' */

/**
 *
 * @enum
 *
 */
export default {
    /**
     *
     * @type {String}
     *
     */
    ANONYMOUS_IP: 'AnonymousIp',
    /**
     *
     * @type {String}
     *
     */
    COUNTRY_CODE: 'CountryCode',
    /**
     *
     * @type {String}
     *
     */
    LOW_CONFIDENCE: 'LowConfidence',
    /**
     *
     * @type {String}
     *
     */
    PROXIED_IP: 'ProxiedIp',
    /**
     *
     * @type {String}
     *
     */
    UNAVAILABLE: 'Unavailable',
    /**
     *
     * @type {String}
     *
     */
    UNKNOWN: 'Unknown',
    /**
     *
     * @type {String}
     *
     */
    ZIP_CODE: 'ZipCode'
};



// WEBPACK FOOTER //
// ./src/services/session/sessionLocationType.js